<template>
  <div v-if="loading" class="fullscreen-centered">
    Loading...
  </div>
  <div v-else>
    <ul class="list-reset">
      <Preview v-for="note in notes" :key="note.id" :note="note" />
    </ul>
    <div v-if="notes.length && more_pages" class="bottom-actions">
      <div v-on:click="loadMore" class="btn btn-outline btn-rounded caps mx-auto" v-bind:class="{ disabled: !more_pages }">
        <pulse-loader v-if="loadMoreBusy" :loading="true" :color="'#000000'" :size="'6px'"></pulse-loader>
        <div v-else>Load more</div>
      </div>
    </div>
    <div v-else class="the-end">
      ✨✨✨<br/>
      You've reached the end!
    </div>
  </div>
</template>

<script>
  import store from '@/store'
  import { mapState } from 'vuex'
  import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
  import Preview from '@/components/Preview'

  export default {
    name: 'Home',
    metaInfo: {
      title: 'Field Notes'
    },
    data () {
      return {
        loading: false,
        loadMoreBusy: false,
        addMenuVisible: false,
        addNew: false,
        totalPages: 0,
        totalResults: 0
      }
    },
    computed: {
      ...mapState([ 'notes', 'drafts', 'current_page', 'total_pages' ]),
      more_pages () {
        return (this.current_page !== this.total_pages)
      }
    },
    mounted () {
      this.getNotes()
    },
    methods: {
      async getNotes () {
        this.loading = true
        const resHeaders = await store.dispatch('getLatestNotes')
        this.totalPages = parseInt(resHeaders['x-wp-totalpages'])
        this.totalResults = parseInt(resHeaders['x-wp-total'])

        this.loading = false
      },
      refresh () {
        this.getNotes()
      },
      async loadMore () {
        try {
          this.loadMoreBusy = true
          const resHeaders = await store.dispatch('getNextPageOfLatestNotes')
          this.totalPages = parseInt(resHeaders['x-wp-totalpages'])
          this.totalResults = parseInt(resHeaders['x-wp-total'])
          this.loadMoreBusy = false
        } catch (err) {
          this.loadMoreBusy = false
          throw err
        }
      }
    },
    components: { Preview, PulseLoader }
  }
</script>

<style scoped>
  .the-end {
    text-align: center;
    margin: 10vh 0;
    line-height: 1.8;
  }
</style>
